import React from 'react';
import PropTypes from 'prop-types';
import clx from 'classnames';
import Spin from '../../../Spin';

export default class Loading extends React.Component {
  static defaultProps = {
    loading: false,
    className: undefined,
  };

  static propTypes = {
    loading: PropTypes.bool,
    loadingText: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  render() {
    const { loading, loadingText, className } = this.props;

    return (
      <Spin
        className={clx(
          'rt-loading',
          {
            '-active': loading,
          },
          className
        )}
        fallbackLabel={loadingText}
        styles={{ overlay: 'rt-loading-overlay' }}
        size="8%"
      />
    );
  }
}
